import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { Box, Grid, Paper, Typography } from '@mui/material';
import BASelect from './BASelect';
import BALoader from './BALoader';

export default function BAPagination(props) {
    const { totalCount, onPageChange, loading } = props
    const [pageSize, setPageSize] = React.useState(20)
    const [pgNo, setPgNo] = React.useState(1)

    return (
        <Paper className='px-4 py-2'>
            <Grid container>
                <Grid item sm={12} xs={12} md={2}>
                    <Box>
                        <BASelect onChange={(e) => {
                            setPageSize(e.target.value)
                            onPageChange(pgNo, e.target.value)
                        }} value={pageSize} displayField="displayName" valueField='id' datasource={[
                            {
                                id: 20,
                                displayName: '20 Rows'
                            },
                            {
                                id: 30,
                                displayName: '30 Rows'
                            },
                            {
                                id: 40,
                                displayName: '40 Rows'
                            },
                        ]} />
                    </Box>
                </Grid>
                <Grid item sm={12} xs={12} md={8}>
                    <Box className='d-flex justify-content-center'>
                        {<Pagination onChange={(e, pageNo) => {
                            setPgNo(pageNo)
                            onPageChange(pageNo, pageSize)
                        }} count={Math.ceil(totalCount / pageSize)} variant="outlined" color="primary" />}
                    </Box>
                </Grid>
                <Grid item sm={12} xs={12} md={2}>
                    <Box>
                        <Typography className='text-center'>
                            Total Records {totalCount}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
}